export default "__VITE_ASSET__8600818e__"